import Banner from "../../sections/common/banner";
import { useLangagesStore } from "../../../context/langages";
import { data as dataES } from "../../../globals/data/es/corporate-identity";
import { data as dataEN } from "../../../globals/data/en/corporate-identity";
import { data as dataCN } from "../../../globals/data/zh/corporate-identity";
import SectionCorporate from "../../sections/home/index/section-corporate";

export default function CorporateIdentityPage() {
    const language = useLangagesStore((state) => state.langage);
    const data = language === "en" ? dataEN : language === "cn" ? dataCN : dataES;

    return (
        <>
            <Banner _data={data.banner} />
            <SectionCorporate _data={data.identity} />
        </>
    )
}